<template>
  <div class="home" style="display: flex">
    <div style="flex: 4" class="treeData" v-loading="loading">
      <!-- 节点关系树 -->
      <vue2-org-tree
        ref="tree"
        @mousewheel.native="controlSize($event)"
        :style="{ transform: 'scale(' + treeSize + ') translate(-50%, -20%)' }"
        :key="treeDataKey"
        v-drag
        v-if="treeData.length && treeData[0].name"
        :data="treeData[0]"
        :horizontal="!horizontal"
        :collapsable="collapsable"
        :render-content="renderContent"
        @on-expand="onExpand"
        @on-node-click="NodeClick"
        :label-class-name="labelClassName"
      />
      <el-empty v-else description="暂无数据"></el-empty>
    </div>
    <!-- 右侧弹框 -->
    <div style="flex: 1">
      <div style="width: 100%; text-align: center"><h4>节点信息</h4></div>
      <!-- 主体内容 -->
      <div class="drawer_container" v-if="drawer == true">
        <el-form
          label-position="right"
          :rules="rules"
          ref="ruleForm"
          :model="formLabel"
        >
          <el-form-item label="节点名称" prop="name">
            <textarea class="textinput" v-model="formLabel.name"></textarea>
          </el-form-item>
          <template v-if="Parts == true">
            <a-form-item label="是否显示培养时间">
              <el-radio-group
                v-model="formLabel.options.isTime"
                style="width: 158px"
              >
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </a-form-item>

            <a-form-item
              label="培养时间类型"
              v-if="formLabel.options.isTime == '1'"
            >
              <el-select
                v-model="formLabel.options.timeType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in dict.TEMPLATE_TIME_TYPE"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </a-form-item>

            <a-form-item
              label="格式化方式"
              v-if="
                formLabel.options.timeType == '1' &&
                formLabel.options.isTime != 0
              "
            >
              <el-select
                v-model="formLabel.options.timeFormat"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in dict.TEMPLATE_TIME_FORMAT"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </a-form-item>

            <a-form-item label="是否显示培养温度">
              <el-radio-group
                v-model="formLabel.options.isTemperature"
                style="width: 158px"
              >
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </a-form-item>

            <a-form-item
              label="培养温度类型"
              v-if="formLabel.options.isTemperature == '1'"
            >
              <el-select
                v-model="formLabel.options.temperatureType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in dict.TEMPLATE_TEMPERATURE_TYPE"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </a-form-item>
          </template>
        </el-form>
        <div style="width: 100%; text-align: center">
          <el-button class="btn save" @click="submitForm('ruleForm', 'save')"
            >保存</el-button
          >
        </div>
      </div>
      <el-empty v-else description="请选择节点"></el-empty>
      <!-- 保存 -->
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="drawer = false">取 消</el-button> -->
        <!-- <el-button class="btn del" @click="clickBtn('del')">删除</el-button> -->
      </span>
    </div>
    <!-- 添加节点 -->
    <el-dialog
      title="添加节点"
      :visible.sync="dialogFormVisible"
      width="20%"
      class="addDialog"
      :modal="false"
    >
      <el-form
        :model="addForm"
        label-position="right"
        :rules="rules"
        ref="addRuleForm"
        label-width="100px"
      >
        <el-form-item label="节点名称" prop="name">
          <el-input
            v-model="addForm.name"
            @keyup.enter.native="submitForm('addRuleForm', 'add')"
          ></el-input>
        </el-form-item>
        <el-form-item label="节点数量">
          <el-input
            @keyup.enter.native="submitForm('addRuleForm', 'add')"
            type="number"
            v-model="addForm.number"
          ></el-input>
        </el-form-item>

        <el-form-item label="关系" prop="type">
          <el-radio-group
            v-model="addForm.type"
            @change="selectType('add')"
            class="typeGroup"
          >
            <!-- 子节点-->
            <div class="nodeRow">
              <el-radio
                :label="item.value"
                v-for="(item, index) in allTypeOptions[2].typeData"
                :key="item.label"
                >{{ item.label }}</el-radio
              >
            </div>
            <!-- 同级 -->
            <div class="nodeRow">
              <el-radio
                :label="item.value"
                v-for="(item, index) in allTypeOptions[1].typeData"
                :key="item.label"
                >{{ item.label }}</el-radio
              >
            </div>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="resetFormBtn">取 消</el-button>
        <el-button type="primary" @click="submitForm('addRuleForm', 'add')"
          >添加</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加分支 -->
    <el-dialog
      title="新建分支"
      :visible.sync="centerDialogVisible"
      width="35%"
      center
    >
      <el-form
        :model="branchMsg"
        label-position="right"
        :rules="rules"
        ref="addbranchMsg"
        label-width="80px"
      >
        <el-form-item label="分支名称" prop="label">
          <el-input
            v-model="branchMsg.label"
            @keyup.enter.native="submitForm('addbranchMsg', 'branchMsg')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetFormBtn">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('addbranchMsg', 'branchMsg')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改分支 -->
    <el-dialog
      title="编辑当前分支名称"
      :visible.sync="editDialogVisible"
      width="35%"
    >
      <el-form
        :model="nodeTreeMsg"
        label-position="right"
        :rules="rules"
        ref="editbranchMsg"
        label-width="80px"
      >
        <el-form-item label="分支名称" prop="treeName">
          <el-input v-model="nodeTreeMsg.treeName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetFormBtn">取 消</el-button>
        <el-button type="danger" plain @click="delNodeTree">删 除</el-button>
        <el-button
          type="primary"
          @click="submitForm('editbranchMsg', 'editBranchName')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<style lang="less">
@import "../../../../styles/home.less";
</style>
<script>
import { allType, classType, rules, randomId } from "../config/filter";
export default {
  watch: {
    nodeTreeValue: {
      handler(n, o) {
        //根据id获取当前分支
        if (n) {
          [this.treeData, this.beforeTreeData] = [
            this.nodeTree.find((item) => {
              return item.value == n;
            }).data,
            this.nodeTree.find((item) => {
              return item.value == n;
            }).data,
          ];
        }
      },
      deep: true,
    },
  },
  name: "Home",
  props: {
    Item: {
      type: Object,
      required: true,
    },
  },
  dicts: [
    "TEMPLATE_TIME_TYPE",
    "TEMPLATE_TIME_FORMAT",
    "TEMPLATE_TEMPERATURE_TYPE",
    "D_METHOD_RESULT_UNIT",
  ],
  data() {
    // 父-father 母-mother 哥-elder_brother  弟-brother 配偶-spouse
    // 姐-elder_sister 妹-younger_sister  儿-son  女-daughter
    return {
      loading: false,
      // 控制右侧内容框
      drawer: false,
      //设置标类名
      labelClassName: "bg-lable",
      // 当前选中标签数据
      formLabel: {},
      // 数据刷新key
      treeDataKey: 0,
      // 所有关系分类数据
      allTypeOptions: [],
      // 折叠超出关系
      moreNode: false,
      // 关系树大小
      treeSize: 1,
      // 节点树分支列表
      nodeTree: [],
      // 当前选中分支
      nodeTreeValue: [],
      //当前选中分支名称
      nodeTreeMsg: {
        treeName: "",
      },
      // 节点搜索输入
      searchNodeName: "",
      // 节点搜索结果
      searchNodeTree: [],
      // 渲染节点树
      treeData: [
        {
          id: 1,
          name: "检测结果模板配置",
          sex: "1",
          type: "father",
          label: "检测结果",
          componentKey: "customization.resultRoot",
          componentName: "",
          children: [
            {
              id: "1hl0hqfi",
              children: [],
              expand: true,
              name: "样品编号",
              sex: "1",
              type: "son",
              label: "样品编号",
              options: {
                isTime: "",
                timeType: "",
                timeFormat: "",
                isTemperature: "",
                temperatureType: "",
              },
              componentKey: "check.sampleNo",
              componentName: "样品编号",
            },
            {
              id: "1hl0ht3k",
              children: [],
              expand: true,
              name: "报告结果",
              sex: "1",
              type: "son",
              label: "报告结果",
              options: {
                isTime: "",
                timeType: "",
                timeFormat: "",
                isTemperature: "",
                temperatureType: "",
              },
              componentKey: "check.result",
              componentName: "报告结果",
            },
          ],
        },
      ],
      beforeTreeData: [],
      // 控制显示方向
      horizontal: true,
      // 控制显示展开按钮
      collapsable: false,
      //控制是否默认展开全部
      expandAll: false,
      // 新增节点弹框
      dialogFormVisible: false,
      // 新建分支弹框
      centerDialogVisible: false,
      // 编辑分支弹框
      editDialogVisible: false,
      // 当前添加的数据
      addForm: {
        id: "",
        children: [],
        number: "1",
        options: {
          isTime: "",
          timeType: "",
          timeFormat: "",
          isTemperature: "",
          temperatureType: "",
        },
        expand: true,
        name: "",
        sex: "1",
        type: "son",
      },
      // 当前添加分支名称
      branchMsg: {
        label: "",
        value: "",
        data: [],
      },
      // 当前添加节点数据
      nowAddNode: {},
      // 当前节点的所有配偶
      spouseArr: [],
      // 选中的配偶
      pitchSpouse: {
        pitchSpouseId: "",
      },
      // 当前添加节点id
      addId: "",
      // 当前选中节点的数据
      currentNodeMsg: {
        fatherArr: {}, //当前节点父节点
        nowNode: {}, //当前节点
        idx: "", //当前节点下标
        type: "", //操作类型
      },
      // 验证规则
      rules: {},
      // 上传txt
      fileList: [],
      Parts: false, // 判断是否为第一级别
      Unit: false,
    };
  },
  methods: {
    // 控制全部展开
    expandChange() {
      this.toggleExpand(this.treeData[0], this.expandAll);
    },
    // 控制方向
    changeHor(val) {
      this.horizontal = val;
    },

    collapse(list) {
      list.forEach((child) => {
        if (child.expand) {
          child.expand = false;
        }
        child.children && this.collapse(child.children);
      });
    },
    onExpand(e, data) {
      if ("expand" in data) {
        data.expand = !data.expand;
        this.changeRender();
        if (data.expand && data.children) {
          this.collapse(data.children);
        }
      } else {
        this.$set(data, "expand", true);
      }
    },
    toggleExpand(data, val) {
      if (Array.isArray(data)) {
        data.forEach((item) => {
          this.$set(item, "expand", val);
          if (item.children) {
            this.toggleExpand(item.children, val);
          }
        });
      } else {
        this.$set(data, "expand", val);
        if (data.children) {
          this.toggleExpand(data.children, val);
        }
      }
    },
    // 获取节点信息
    NodeClick(e, data) {
      // 深拷贝对象改变地址
      this.formLabel = JSON.parse(JSON.stringify(data));
      this.formLabel.name = this.formLabel.componentName;
      console.log(data, "当前点击节点信息");
      console.log(this.treeData[0].children, "所有子节点信息");

      // 打开弹框
      this.drawer = true;
        // 遍历 this.treeData[0].children 数组，查找是否有节点的 name 与 data.name 一致
        for (const child of this.treeData[0].children) {
          if (child.name === data.name) {
            if (!child.options) {
           data.options = {
                isTime: "",
                timeType: "",
                timeFormat: "",
                isTemperature: "",
                temperatureType: "",
              };
            }
            this.Parts = true; // 如果找到匹配的节点，则将 Parts 设置为 true
            break; // 找到匹配节点后跳出循环
          }
        }
      this.formType = true;
    },

    // 渲染数据
    renderContent(h, data) {
      return (
        <div>
          <el-popover placement="top-start" trigger="hover">
            <div style="display:flex">
              <el-button
                size="mini"
                class="addBtn"
                type="primary"
                icon="el-icon-circle-plus-outline"
                onClick={() => {
                  this.openAddFrom(data);
                }}
              >
                添加
              </el-button>
              <el-button
                type="danger"
                size="mini"
                class="addBtn"
                icon="el-icon-circle-close"
                onClick={() => {
                  this.clickBtn("del", data);
                }}
              >
                删除
              </el-button>
            </div>
            <div slot="reference">
              <div class="treeItem">
                <div class="controlIcon">
                  <i class={classType(data.type)}></i>
                </div>
                <span class="item_name">{data.name || data.componentName}</span>
              </div>
            </div>
          </el-popover>
        </div>
      );
    },
    // 删除1
    clickBtn(type, data) {
      this.formLabel = JSON.parse(JSON.stringify(data));
      console.log(this.formLabel, "formLabel");
      if (data.name == "报告结果" || data.name == "样品编号") {
        this.$message.warning("该节点无法删除");
      } else {
        if (this.formLabel.id == 1) {
          this.$message.warning("根节点无法删除");
        } else {
          if (type === "del") {
            if (this.formLabel.children.length > 0) {
              this.$message.warning("请先删除其下子节点才可以删除该节点");
              return;
            }
            this.check(this.treeData, this.formLabel.id, type);
            this.formLabel = {};
          }
        }
      }
    },
    // 保存/添加
    submitForm(formName, type) {
      if (this.$refs[formName]) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // 添加节点
            if (type === "add") {
              //   this.treeData[0].children.splice(1, 0, this.addForm);
              this.check(this.treeData, this.addId, type);
            }
            //保存
            if (type === "save") {
              this.check(this.treeData, this.formLabel.id, type);
            }
            // 新建分支
            if (type === "branchMsg") {
              this.addNodeTree();
            }
            // 编辑分支名
            if (type === "editBranchName") {
              this.saveNodeName();
            }
          }
          return false;
        });
      }
    },
    // 关系选择时判断性别是否正确
    selectType(type) {
      let men = ["father", "son", "elder_brother", "younger_brother"]; //spouse
      let women = ["mother", "elder_sister", "younger_sister", "daughter"];
      // 添加
      if (type == "add") {
        if (this.addForm.sex != 2) {
          // 先判断是否是配偶
          if (this.addForm.type == "spouse") {
            return;
          } else {
            // 判断当前关系是否术属于女性
            if (women.includes(this.addForm.type)) {
              this.addForm.sex = "0";
            } else {
              this.addForm.sex = "1";
            }
          }
        }
      }
      if (type == "edit") {
        if (this.formLabel.sex != 2) {
          // 先判断是否是配偶
          if (this.addForm.type == "spouse") {
            return;
          } else {
            // 判断当前关系是否术属于女性
            if (women.includes(this.formLabel.type)) {
              this.formLabel.sex = "0";
            } else {
              this.formLabel.sex = "1";
            }
          }
        }
      }
    },
    // 优化节点操作
    check(data, id, type, callback) {
      this.loading = true;
      this.findNodeInTree(data, id, type, (item, index, arr) => {
        this.currentNodeMsg.idx = index;
        this.currentNodeMsg.nowNode = item;
      });
      switch (type) {
        // 删除
        case "del":
          this.currentNodeMsg.fatherArr.children.splice(
            this.currentNodeMsg.idx,
            1
          );
          this.$message.success("删除成功!");
          break;
        // 修改-保存
        case "save":
          // 判断是否是根节点
          if (
            this.currentNodeMsg.fatherArr.hasOwnProperty("name") ||
            this.currentNodeMsg.fatherArr.hasOwnProperty("componentName")
          ) {
            console.log(this.formLabel, "formLabel");
            this.currentNodeMsg.fatherArr.children.splice(
              this.currentNodeMsg.idx,
              1,
              this.formLabel
            );
            this.formLabel.componentName = this.formLabel.name;
          } else {
            data[0] = this.formLabel;
          }
          // 关闭修改框
          this.$message.success("修改成功!");
          this.formType = false;
          break;
        // 新增
        case "add":
          let level = this.currentNodeMsg.idx; // 获取当前节点的级别
          let numberOfNodesToAdd = parseInt(this.addForm.number); // 获取要新增的节点数量

          if (isNaN(numberOfNodesToAdd) || numberOfNodesToAdd <= 0) {
            this.$message.warning("请输入有效的节点数量!");
            break;
          }

          for (let i = 0; i < numberOfNodesToAdd; i++) {
            let newNode = {
              ...this.addForm, // 复制新增节点对象的属性
              id: randomId() + i + "_" + level, // 加上级别和循环索引后缀作为节点ID
              label: "",
              componentKey: "customization.resultChild",
              componentName: this.addForm.name + "_" + i,
              options: {}, // 创建空的options对象
              name: this.addForm.name + "_" + i
            };

            if (level === 0 || level === 1) {
              newNode.options = {
                isTime: "",
                timeType: "",
                timeFormat: "",
                isTemperature: "",
                temperatureType: "",
              };
            }
            if (!this.currentNodeMsg.fatherArr) {
              this.currentNodeMsg.fatherArr = { children: [] };
            }
            if (newNode.type === "son") {
              this.currentNodeMsg.nowNode.children.splice(
                this.currentNodeMsg.idx + 1,
                0,
                newNode
              );
            } else if (newNode.type === "elder_brother") {
              // 添加同级节点
              const children = this.currentNodeMsg.fatherArr.children;
              children.splice(this.currentNodeMsg.idx + 1, 0, newNode);
            }
          }

          this.$message.success("添加成功!");
          break;
      }
      this.loading = false;
      this.resetFormLabel();
      this.resetNowNode();
      this.resetFormBtn();
      this.changeRender();
    },
    findInsertIndex(children, newNode) {
      let index = children.length;
      for (let i = 0; i < children.length; i++) {
        if (children[i].id > newNode.id) {
          index = i;
          break;
        }
      }
      return index;
    },
    findNodeInTree(data, id, type, callback) {
      this.currentNodeMsg.type = type;
      for (let i = 0; i < data.length; i++) {
        if (data[i].id == id) {
          return callback(data[i], i, data);
        }
        if (data[i].children) {
          let hasId = data[i].children.find((item) => {
            if (item.id == id) {
              this.currentNodeMsg.fatherArr = data[i];
            }
          });
          this.findNodeInTree(data[i].children, id, type, callback);
        }
      }
    },
    // 判断节点名称是否重复
    branchNameRepeat(name) {
      let isRepeat = this.nodeTree.find((item) => {
        return item.label == name;
      });
      return isRepeat ? true : false;
    },
    //判断当前节点的子节点中是否包含配偶
    branchSpouse(data) {
      // 有子节点时
      if (data.length > 0) {
        data.forEach((item, index) => {
          if (item.type == "spouse") {
            this.spouseArr.push(item);
          }
        });
      }
      return this.spouseArr.length ? true : false;
    },
    // 新建节点树
    addNodeTree() {
      this.loading = true;
      // 判断当前分支是否存在
      let state = this.branchNameRepeat(this.branchMsg.label);
      if (state) {
        this.$message.warning("分支名不能重复");
        this.loading = false;
        return;
      }
      this.branchMsg.value = randomId();
      // 赋予默认根节点
      this.branchMsg.data.push({
        id: randomId(),
        name: "始先祖",
        sex: "1",
        type: "father",
        children: [],
      });
      this.centerDialogVisible = false;
      this.nodeTree.push(this.branchMsg);
      this.nodeTreeValue = this.branchMsg.value;
      this.$message.success("新建成功!");
      this.loading = false;
      this.resetFormBtn();
    },
    // 修改当前分支名
    editNodeName() {
      if (this.nodeTreeValue) {
        this.loading = true;
        this.editDialogVisible = true;
        // 当前分支名称
        [this.nodeTreeMsg.treeName, this.nodeTreeMsg.nodeValue] = [
          this.nodeTree.find((item) => {
            return item.value == this.nodeTreeValue;
          }).label,
          this.nodeTree.find((item) => {
            return item.value == this.nodeTreeValue;
          }).value,
        ];
        this.loading = false;
        return;
      }
      this.$message.warning("当前未选中分支");
    },
    // 保存修改的分支名
    saveNodeName() {
      this.loading = true;

      // 修改当前分支名称
      // let arr = this.nodeTree.find((item) => {
      //   return item.value == this.nodeTreeMsg.nodeValue
      // })
      this.nodeTree.forEach((item, index) => {
        if (item.value == this.nodeTreeMsg.nodeValue) {
          let state = this.branchNameRepeat(this.nodeTreeMsg.treeName);
          if (state) {
            this.$message.warning("分支名不能重复");
            this.loading = false;
            return;
          }
          item.label = this.nodeTreeMsg.treeName;
          this.$message.success("修改成功");
          this.loading = false;
          this.editDialogVisible = false;
          return;
        }
      });
    },
    // 删除当前节点树
    delNodeTree() {
      this.$confirm("确定删除该分支吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.nodeTree = this.nodeTree.filter((item) => {
            return item.value != this.nodeTreeValue;
          });
          this.nodeTreeValue = this.nodeTree[0].value;
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.editDialogVisible = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
          this.editDialogVisible = false;
        });
    },
    // 重新渲染关系树
    changeRender() {
      this.treeDataKey += 1;
    },
    // 重置当前详情弹框数据
    resetFormLabel() {
      this.drawer = false;
      this.formLabel = {};
    },
    //打开表单对话框
    openAddFrom(data) {
      console.log(data, "========>>");
      this.spouseArr = [];
      this.pitchSpouse = {
        pitchSpouseId: "",
      };
      this.dialogFormVisible = true;
      this.nowAddNode = data;
      this.addId = data.id;
      this.branchSpouse(this.nowAddNode.children);
      // let isBranchSpouse = this.branchSpouse(this.nowAddNode.children)
    },

    // 取消添加
    resetFormBtn() {
      (this.addForm = {
        id: "",
        children: [],
        expand: true,
        name: "",
        sex: "1",
        type: "son",
      }),
        (this.dialogFormVisible = false);
      this.centerDialogVisible = false;
      this.editDialogVisible = false;
      this.addId = "";
      this.nowAddNode = "";
      // 清空新建分支名
      this.branchMsg = {
        label: "",
        value: "",
        data: [],
      };
      //清空编辑当前分支名
      this.nodeTreeMsg = {
        treeName: "",
        nodeValue: "",
      };
      // 清空当前节点下的所有配偶节点
      this.spouseArr = [];
      // 打开关系折叠面板
      this.moreNode = this.allTypeOptions.length > 1 ? true : false;
    },
    // 重置当前选项
    resetNowNode() {
      this.currentNodeMsg = {
        fatherArr: {}, //当前节点父节点
        nowNode: {}, //当前节点
        idx: "", //当前节点下标
        type: "", //操作类型
      };
    },
    // 滚轮控制树形大小
    controlSize(e) {
      e.preventDefault();
      let direction = e.deltaY > 0 ? "down" : "up";
      if (direction === "up") {
        // 滑轮向上滚动放大
        this.treeSize += 0.1;
      } else {
        // 滑轮向下滚动缩小
        this.treeSize <= 0.5 ? false : (this.treeSize -= 0.1);
      }
    },
  },
  mounted() {
    console.log(this.Item, "当前点击节点传递进来的信息");
    if (this.Item.children.length > 0) {
      this.treeData[0].children = this.Item.children[0].children;
    } else {
      console.log(this.treeData[0], "没有配置的数据");
    }
  },
  created() {
    // this.toggleExpand(this.treeData[0], this.expandAll);
    this.allTypeOptions = allType;
    this.moreNode = this.allTypeOptions.length > 1 ? true : false;
    this.rules = rules;
  },
  components: {},
};
</script>
